import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Grid,
  LinearProgress,
  Modal,
} from "@mui/material";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "@mui/material/Checkbox";
import {
  getSourcePath,
  getText,
} from "../../../core/Constant";
import _ from "lodash";
import {
  CircularWithValueLabel,
  ConfirmQuiz,
  DialogComponent,
} from "../../atom";
import FlagIcon from "@mui/icons-material/Flag";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import HeadingComponent from "../../atom/Headings/Heading";
import { useSelector } from "react-redux";
import WaterMark from '@uiw/react-watermark';
import UserRepository from '../../../core/repository/UserRepository';
import { useWatermarkProtection } from "../../../hook/useWatermarkProtection";

const QuizMainCard = ({
  data,
  length,
  index,
  showFinish = false,
  attempt = false,
  onNext = () => {},
  onBack = () => {},
  answers = [],
  quizName,
  duration,
  quizId,
  quizWeek,
  start,
  min,
  seconds,
  time,
  newList = [],
  onSubmitLast = () => {},
  onComplet = () => {},
}) => {
  const [watermarkKey, setWatermarkKey] = useState(0);
  const [answer, setAnswer] = useState([]);
  const [userInfo, setUserInfo] = useState({
    name: "",
    contact: "",
    email: "",
  });
  const hasTriggeredRef = useRef(false);
  
    const sendTamperingAlert = async () => {
      try {
        const res = await UserRepository.temperingAlertMail();
      } catch (e) {
        console.error("Tampering alert error:", e);
      }
    };

    useWatermarkProtection({
    onTamper: () => {
      if (!hasTriggeredRef.current) {
      hasTriggeredRef.current = true;
      sendTamperingAlert(); 
    }
    setWatermarkKey(prev => prev + 1);
    }
  });

  // Fetch user details
  useEffect(() => {
    const getUser = async () => {
      const user = await UserRepository.getUserDetail();
      setUserInfo({
        name: `${user?.data?.first_name || ""} ${user?.data?.last_name || ""}`.trim(),
        contact: user?.data?.phone_number || "",
        email: user?.data.email || "",
      });
    };
    getUser();
  }, []);
  const [submitDialog, setSubmitDialog] = useState();
  const [isFlag, setIsFlag] = useState(false);
  const [show, setShow] = useState(false);
  const [images, setImages] = useState([]);

  const loadingAction = useSelector((state) =>
    state.common.get("loadingAction")
  );

  useEffect(() => {
    // Handle images - can be single or multiple
    if (data?.images) {
      if (Array.isArray(data.images) && data.images.length > 0) {
        // If it's an array, even if it has one item, handle it as multiple
        const imageArray = data.images.map((img) =>
          img?.image_path ? getSourcePath(img.image_path) : null
        );
        setImages(imageArray.filter(Boolean)); // Filter out null or undefined paths
      } else {
        setImages([]); // If no valid images
      }
    } else {
      setImages([]); // If no images field is present
    }
  }, [data]);

  useEffect(() => {
    if (loadingAction?.action?.type == "STD_STUDENT_ANSWERS") {
      setShow(loadingAction?.loading);
    }
  }, [loadingAction]);

  useEffect(() => {
    const anw = _.get(answers, "answer", []);
    if (anw.length > 0) {
      setAnswer(anw);
    } else {
      setAnswer([]);
    }
    setIsFlag(_.get(answers, "is_flag", false));
  }, [answers, data]);

  const onClickFlag = () => {
    setIsFlag(!isFlag);
  };

  const handleChange = (event) => {
    const text = getText(event);
    setAnswer([text]);
  };

  const handlechangeForm = (event) => {
    const text = getText(event);
    const isChecked = _.findIndex(answer, (i) => i == text) > -1;
    if (!isChecked) {
      setAnswer([...answer, text]);
    } else {
      const anw = _.filter(answer, (i) => i !== text);
      setAnswer(anw);
    }
  };

  const onClick = () => {
    if (index == length) {
      const data = {
        ...newList[index],
        isAnswered: answer?.length > 0 ? 1 : 0,
        isFlag: isFlag ? 1 : 0,
      };
      newList[index] = data;
      setSubmitDialog(true);
      onsubmit(true);
    } else {
      onsubmit(false);
    }
  };

  const onsubmit = (isSubmiit) => {
    const object = {
      id: data.question_id,
      type: data.type,
      answer,
      isAnswered: answer?.length > 0 ? 1 : 0,
      isFlag: isFlag ? 1 : 0,
    };
    onNext(object);

    setAnswer([]);
    setIsFlag(false);
  };

  const getFormattedTime = () => {
    // Convert to numbers and handle non-numeric cases
    const minValue = Number(min) || 0;
    const secValue = Number(seconds) || 0;

    // Round to integers and clamp to 0 if negative
    const displayMin = Math.max(0, Math.floor(minValue));
    const displaySec = Math.max(0, Math.floor(secValue));

    // Ensure seconds are two digits
    return `${displayMin}:${displaySec < 10 ? "0" + displaySec : displaySec}`;
  };

  return (
    <Box  className="watermark-protection" sx={{ position: 'relative' }}>
      {/* Watermark overlay */}
      <WaterMark  key={watermarkKey} className="watermark-protection"
        content={[
                  userInfo.name,
                  userInfo.contact,
                  userInfo.email,
                ]}
        gap={[10, 10]}
        fontSize={12}
        zIndex={10}
        rotate={-20}
        offsetLeft={50}
        fontColor="rgba(0, 0, 0, 0.25)"
      > 
      <Grid container flexDirection={"column"} gap={2} sx={{ position: 'relative', zIndex: 1 }}>
        <Grid item>
          <Grid
            container
            justifyContent={"space-between"}
            alignItems={"flex-start"}
          >
            <Grid item>
              <Box>
                <HeadingComponent
                  text={quizName}
                  fontweigth={600}
                  size={26}
                  fontfamily={"Montserrat"}
                />

                <Box>
                  {/* <p className="quiz-title-assest">Quiz {quizId}</p> */}
                  <p
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      fontFamily: "Montserrat",
                      fontSize: 20,
                    }}
                  >
                    {/* {quizWeek} */}
                  </p>
                </Box>
              </Box>
            </Grid>

            <Grid item>
              <Box sx={{ display: "flex", gap: 1 }}>
                {start ? (
                  <Box
                    onClick={onClickFlag}
                    sx={{
                      width: "50px",
                      border: "solid",
                      borderWidth: 1,
                      textTransform: "capitalize",
                      justifyContent: "center",
                      alignItems: "center",
                      display: "flex",
                      borderRadius: 2,
                      borderColor: isFlag ? "transparent" : "black",
                      "&:hover": {
                        backgroundColor: "#FFB200 !important",
                        color: "#fff !important",
                      },
                      backgroundColor: isFlag
                        ? "#FFB200 !important"
                        : "#ffffff",
                    }}
                  >
                    {isFlag ? (
                      <FlagIcon sx={{ color: "#ffffff" }} fontSize="small" />
                    ) : (
                      <FlagOutlinedIcon color="secondary" fontSize="small" />
                    )}
                  </Box>
                ) : null}

                {/* <CircularWithValueLabel
                  duration={duration}
                  color="#28b882"
                  text={start ? min + ":" + seconds : duration}
                  progress={time}
                /> */}
                <CircularWithValueLabel
                  duration={duration}
                  color="#28b882"
                  text={start ? getFormattedTime() : duration}
                  progress={time}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {show ? (
          <Grid item>
            <Grid container>
              <Grid item sx={{ width: "100%", height: 20 }}>
                <Box>
                  <LinearProgress />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
        <Grid item>
          <Grid container gap={2} flexDirection="column">
            <Grid item xs={12}>
              <div
                dangerouslySetInnerHTML={{
                  __html: `${index}. ${data?.question}`,
                }}
              />
            </Grid>
            {images.length > 0 && (
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    marginTop: 1,
                  }}
                >
                  {images.map((imgSrc, imgIndex) => (
                    <Box
                      key={`quiz-image-${imgIndex}`}
                      sx={{
                        flex: "1 1 240px",
                        maxWidth: "100%",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: 1,
                        backgroundColor: "white",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          overflow: "hidden",
                          borderRadius: "4px",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        <img
                          src={imgSrc}
                          alt={`Question Image ${imgIndex + 1}`}
                          style={{
                            width: "100%",
                            height: "auto",
                            maxHeight: "320px",
                            objectFit: "contain", // Ensures image is not cut
                          }}
                        />
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item>
          {data?.type == 2 ? (
            <FormControl
              variant="outlined"
              margin="normal"
              component="fieldset"
              defaultValue={[]}
              onChange={handlechangeForm}
              sx={{ width: "100%" }}
            >
              <FormGroup
                style={{
                  display: "grid",
                  gap: 5,
                  gridTemplateColumns: "repeat(2, 1fr)",
                }}
              >
                {data?.answers?.map((item, index) => {
                  const isChecked =
                    _.findIndex(answer, (i) => i == item.id) > -1;
                  return (
                    <Box sx={{ padding: 0 }} className="quiz-box">
                      <FormControlLabel
                        style={{ width: "100%", padding: 15 }}
                        value={item.id}
                        control={<Checkbox checked={isChecked} />}
                        label={`${item?.answer}`}
                      />
                    </Box>
                  );
                })}
              </FormGroup>
            </FormControl>
          ) : (
            <FormControl sx={{ width: "100%" }}>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                value={answer}
                onChange={handleChange}
                style={{
                  display: "grid",
                  gap: 5,
                  gridTemplateColumns: "repeat(2, 1fr)",
                }}
              >
                {data?.answers?.map((item, index) => {
                  const isChecked = answer[0] == item.id;
                  // Map item.id to letter: 1->A, 2->B, ...
                  const labelLetter = String.fromCharCode(64 + Number(item.id)); // 65 is 'A', so 1->A
                  return (
                    <Box
                      sx={{ padding: 0 }}
                      className="quiz-box"
                      key={item.id}
                    >
                      <FormControlLabel
                        style={{ width: "100%", padding: 15 }}
                        value={item.id}
                        control={<Radio checked={isChecked} />}
                        label={`${labelLetter}. ${item.answer}`}
                      />
                    </Box>
                  );
                })}
              </RadioGroup>
            </FormControl>
          )}
        </Grid>
        <Grid item>
          <Grid container gap={2} justifyContent={"flex-end"}>
            {index == 1 ? null : (
              <Grid item xl={2}>
                <TextButtonComponet
                  onButtonClick={onBack}
                  classStyle="btn btn-secondary"
                  text={"Back"}
                />
              </Grid>
            )}

            <Grid item xl={2}>
              <TextButtonComponet
                onButtonClick={onClick}
                text={length == index ? "Finish" : "Save"}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <DialogComponent
        title={"Questions you answered"}
        isShowCloseButton={true}
        btntextone={"Confirm & Submit"}
        btntexttwo={"Cancel"}
        open={submitDialog}
        children={<ConfirmQuiz list={newList} />}
        onClose={() => setSubmitDialog(false)}
        onclickone={() => {
          setSubmitDialog(false);
          onComplet();
        }}
      />

      <Modal open={show}>
        <div style={{ height: "100%", width: "100%" }}></div>
      </Modal>
      </WaterMark>
    </Box>
  );
};

export default QuizMainCard;
